import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Person } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const AttendantNode = memo(({ id, data, isConnectable, selected }) => {
  const userName = data?.userName || data?.user?.name;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Person />}
      title="Atendente"
      color="#3aba38"
      bgColor="#ffffff"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: userName ? "#E8F5E9" : "#f5f5f5",
          color: userName ? "#2e7d32" : "#999",
          border: `1px solid ${userName ? "#3aba3830" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Person style={{ fontSize: 14, color: userName ? "#3aba38" : "#bbb" }} />
        {userName || "Nenhum atendente"}
      </div>
    </NodeWrapper>
  );
});

AttendantNode.displayName = "AttendantNode";
export default AttendantNode;
